export const deClientPortalDashboardPage = {
    allPortfolios: 'Alle Portfolios',
    noPortfoliosAvailable: 'Keine Portfolios verfügbar',
    rentalIncome: 'Mieteinnahmen',
    marketValueDevelopment: 'Entwicklung Marktwert',
    marketRentDevelopment: 'Entwicklung Marktmiete',
    marketValueShare: 'Marktwertanteil',
    mapOverview: 'Kartenübersicht',
    portfolioMarketValueShare: 'Marktwertanteil Portfolio',
    formulas: {
        grossYield: '\\frac{\\text{Marktmiete} \\times 100}{\\text{Marktwert}}',
    },
}
